export type UserAuthorizationType = 'denied' | 'pending' | 'allowed' | 'goToLogin'
export const UserAuthorization = {
    Denied: 'denied' as UserAuthorizationType,
    Pending: 'pending' as UserAuthorizationType,
    Allowed: 'allowed' as UserAuthorizationType,
    GoToLogin: 'goToLogin' as UserAuthorizationType /* used when the api returns a 401 from the backend */
}
